import React, { useState } from "react";
import AddSurvey from "../../admin/survey/AddSurvey";
import ListSurvey from "../../admin/survey/ListSurvey";

const SurveysT = ({ surveys, setSurveys }) => {
  
  const [activeTab, setActiveTab] = useState("Survey"); // Default tab

  return (
    <div>
      {/* Tabs */}
      <div className="flex space-x-4 border-b mb-4">
        <button
          onClick={() => setActiveTab("Survey")}
          className={`px-4 py-2 ${
            activeTab === "Survey" ? "text-[#241763] border-b-2 border-[#241763]" : "text-gray-500"
          }`}
        >
          Survey
        </button>
        <button
          onClick={() => setActiveTab("List Survey")}
          className={`px-4 py-2 ${
            activeTab === "List Survey" ? "text-[#241763] border-b-2 border-[#241763]" : "text-gray-500"
          }`}
        >
          Survey Response
        </button>
      </div>

      {/* Survey Tab Content */}
      {activeTab === "Survey" && (
        <AddSurvey  />
      
      )}

      {/* List Survey Tab Content */}
      {activeTab === "List Survey" && (
        <ListSurvey />
      )}

    </div>
  );
}

export default SurveysT;
